import { render, staticRenderFns } from "./Calendar.vue?vue&type=template&id=f5895556&scoped=true"
import script from "./Calendar.vue?vue&type=script&lang=js"
export * from "./Calendar.vue?vue&type=script&lang=js"
import style0 from "./Calendar.vue?vue&type=style&index=0&id=f5895556&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5895556",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5895556')) {
      api.createRecord('f5895556', component.options)
    } else {
      api.reload('f5895556', component.options)
    }
    module.hot.accept("./Calendar.vue?vue&type=template&id=f5895556&scoped=true", function () {
      api.rerender('f5895556', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/dashboard_widgets/Calendar.vue"
export default component.exports